<!-- src/components/course/CertificatesList.vue -->
<template>
  <div class="certificates-list">
    <div class="certificates-list__header">
      <h3 class="certificates-list__title">Сертификаты</h3>
      
      <div class="certificates-list__actions">
        <button
          class="certificates-list__add-btn"
          type="button"
          @click="createVisual"
        >
          Создать шаблон
        </button>
      </div>
    </div>

    <div v-if="loading" class="certificates-list__loading">
      <div class="spinner"></div>
      <p>Загрузка сертификатов...</p>
    </div>

    <div v-else-if="certificates.length === 0" class="certificates-list__empty">
      <div class="certificates-list__empty-icon" aria-hidden="true">
        <svg
          class="certificates-list__empty-icon-svg"
          width="96"
          height="96"
          viewBox="0 0 96 96"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="48" cy="48" r="44" fill="url(#cert_bg)" />
          <circle cx="48" cy="48" r="44" stroke="#C6DAF7" stroke-width="2" />

          <path
            d="M32 18l16 8 16-8v10c0 10.5-7.2 19.9-16 22-8.8-2.1-16-11.5-16-22V18z"
            fill="url(#cert_main)"
            stroke="#3B82F6"
            stroke-width="2"
            stroke-linejoin="round"
          />
          <path
            d="M26 18l6 3v9c0 7.7 4.3 14.7 10.8 18.7"
            stroke="#8BB6FF"
            stroke-width="2"
            stroke-linecap="round"
          />
          <path
            d="M70 18l-6 3v9c0 7.7-4.3 14.7-10.8 18.7"
            stroke="#8BB6FF"
            stroke-width="2"
            stroke-linecap="round"
          />

          <circle cx="48" cy="54" r="12" fill="url(#cert_medal)" stroke="#2F6BD9" stroke-width="2" />
          <path
            d="M48 47l2.4 4.8 5.3.8-3.8 3.7.9 5.3-4.8-2.5-4.8 2.5.9-5.3-3.8-3.7 5.3-.8L48 47z"
            fill="#FBBF24"
            stroke="#F59E0B"
            stroke-width="1"
            stroke-linejoin="round"
          />

          <path d="M40 70l-4 10 8-4 4-6" fill="#9EC5FF" />
          <path d="M56 70l4 10-8-4-4-6" fill="#9EC5FF" />

          <circle cx="22" cy="30" r="2.5" fill="#93C5FD" />
          <circle cx="74" cy="30" r="2.5" fill="#93C5FD" />
          <circle cx="64" cy="16" r="2" fill="#BFD6F6" />
          <circle cx="32" cy="16" r="2" fill="#BFD6F6" />
          <defs>
            <linearGradient id="cert_bg" x1="12" y1="8" x2="84" y2="88" gradientUnits="userSpaceOnUse">
              <stop stop-color="#F8FAFF" />
              <stop offset="1" stop-color="#E8F1FF" />
            </linearGradient>
            <linearGradient id="cert_main" x1="32" y1="18" x2="64" y2="62" gradientUnits="userSpaceOnUse">
              <stop stop-color="#E0F2FE" />
              <stop offset="1" stop-color="#BFDBFE" />
            </linearGradient>
            <radialGradient id="cert_medal" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(48 54) rotate(90) scale(12)">
              <stop stop-color="#FFE08A" />
              <stop offset="1" stop-color="#FBBF24" />
            </radialGradient>
          </defs>
        </svg>
      </div>
      <p class="certificates-list__empty-text">Шаблоны сертификатов ещё не созданы</p>
      <p class="certificates-list__empty-subtext">
        По умолчанию используется глобальный шаблон, но вы можете создать индивидуальный для курса.
      </p>
    </div>

    <div v-else class="certificates-list__items">
      <CertificateCard
        v-for="certificate in certificates"
        :key="certificate.id"
        :certificate="certificate"
        @edit="$emit('edit-certificate', $event)"
        @delete="$emit('delete-certificate', $event)"
        @preview="$emit('preview-certificate', $event)"
      />
    </div>
  </div>
</template>

<script>
import CertificateCard from './CertificateCard.vue'

export default {
  name: 'CertificatesList',
  
  components: {
    CertificateCard,
  },
  
  props: {
    certificates: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  
  methods: {
    createVisual() {
      this.$emit('create-certificate')
    },
  }
}
</script>

<style scoped>
.certificates-list {
  width: 100%;
  padding: 40px;
}

.certificates-list__header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 24px;
  gap: 20px;
}

.certificates-list__title {
	color: #000000;
	font-size: 25px;
	font-weight: 700;
	letter-spacing: 0;
	line-height: normal;
	margin: 0;
}

/* Actions */
.certificates-list__actions {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 8px;
  text-align: right;
}

.certificates-list__add-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  background: #0095ec;
  color: #ffffff;
  border: none;
  border-radius: 12px;
  padding: 12px 24px;
  font-size: 17px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s ease;
}

.certificates-list__add-btn:hover {
  transform: translateY(-2px);
  background: #0085d4;
}

.certificates-list__note {
  margin: 0;
  color: #6b7280;
  font-size: 13px;
  line-height: 1.4;
  max-width: 360px;
}

/* Loading */
.certificates-list__loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 80px 20px;
  color: #636363;
  font-family: 'Poppins', Helvetica, sans-serif;
  font-size: 14px;
}

.spinner {
  width: 48px;
  height: 48px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #0095ec;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 16px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* Empty State */
.certificates-list__empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 80px 20px;
  text-align: center;
}

.certificates-list__empty-icon {
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.certificates-list__empty-icon-svg {
  width: 96px;
  height: 96px;
  filter: drop-shadow(0 12px 24px rgba(15, 23, 42, 0.12));
  animation: floatCert 3.2s ease-in-out infinite;
}

@keyframes floatCert {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-10px);
  }
}

.certificates-list__empty-text {
  color: #252641;
  font-family: 'Poppins', Helvetica, sans-serif;
  font-size: 20px;
  font-weight: 600;
  margin: 0 0 8px 0;
}

.certificates-list__empty-subtext {
  color: #636363;
  font-family: 'Poppins', Helvetica, sans-serif;
  font-size: 14px;
  margin: 0 0 32px 0;
  max-width: 400px;
  line-height: 1.6;
}

.certificates-list__empty-actions {
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
  justify-content: center;
}

.certificates-list__empty-btn {
  padding: 14px 28px;
  border: none;
  border-radius: 12px;
  font-family: 'Poppins', Helvetica, sans-serif;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
}

.certificates-list__empty-btn--primary {
  background: linear-gradient(135deg, #0095ec 0%, #0077be 100%);
  color: #ffffff;
  box-shadow: 0 4px 12px rgba(0, 149, 236, 0.3);
}

.certificates-list__empty-btn--primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0, 149, 236, 0.4);
}

.certificates-list__empty-btn--secondary {
  background: #f5f5f5;
  color: #252641;
}

.certificates-list__empty-btn--secondary:hover {
  background: #e8e8e8;
  transform: translateY(-2px);
}

/* Grid */
.certificates-list__items {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 24px;
}

/* Responsive */
@media (max-width: 768px) {
  .certificates-list {
    padding: 16px;
  }
  
  .certificates-list__header {
    flex-direction: column;
    gap: 12px;
    align-items: stretch;
  }
  
  .certificates-list__add-btn {
    justify-content: center;
  }
  
  .certificates-list__actions {
    align-items: flex-start;
    text-align: left;
  }
  
  .certificates-list__empty-actions {
    flex-direction: column;
  }
  
  .certificates-list__empty-btn {
    width: 100%;
  }
}
</style>
